'use client';

import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';

const baseStyle = defineStyle({
  textStyle: 'heading.xs',
  fontWeight: 'bold', // this is required despite the textStyle because the font weight defaults to 'medium' for some reason
  color: 'text/body',
  mb: 1,
  _disabled: {
    opacity: 1
  }
});

export const formLabelTheme = defineStyleConfig({
  baseStyle
});
